import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./index.scss";
const MyFilterButton = ({ icon, type, items, width, onChange, disabled,className, ...props }) => {
  const [title, setTitle] = useState(props.title);
  return (
    <div className="d-flex justify-content-between">
      <div className={disabled ?  'grid-view Dropdown__disabled mr-5 h-50px' : `grid-view mr-5 h-50px ${className}`}>
        <Dropdown className="align-self-center">
          <Dropdown.Toggle
            id="dropdown-button-dark-example2"
            className="my-filter__toggle"
            variant="red"
            style={{ width: width }}
            disabled={disabled}
          >
            <div className="filter-text" style={{ display: "contents" }}>
            {icon && icon}
              {`${type ? `${type}:` : "" } ${title}`}
              <KeyboardArrowDownIcon className="ml-2" fontSize="small" style={{ width: 16 }} />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="mt-2 my-filter__menu">
            {items.map((item, index) => {
              return (
                <Dropdown.Item
                  key={index}
                  onClick={() => {
                    setTitle(item.label);
                    onChange(item.value);
                  }}
                >
                  {item.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
export default MyFilterButton;
